import React, { Fragment } from "react";
import { Query } from "react-apollo";
import { func, string } from "prop-types";
import { FUNDS_RECIPIENT_QUERY } from "../queries";
import UserCampaign from "./UserCampaign";

export default class UserCampaignList extends React.Component {
  static propTypes = {
    setCampaign: func.isRequired,
    currency: string.isRequired,
  };

  state = {
    checkedRadio: null,
  };

  changeRadio = (campaignId) => {
    this.setState({ checkedRadio: campaignId });
  };

  render() {
    const { setCampaign, currency } = this.props;
    const { checkedRadio } = this.state;
    return (
      <Query query={FUNDS_RECIPIENT_QUERY} variables={{ currency }}>
        {({ data, loading }) => {
          if (loading) {
            return <span>Loading campaigns...</span>;
          }

          const myCampaigns = data.Viewer.runningCampaigns;

          if (myCampaigns.length === 0) {
            return null;
          }

          return (
            <>
              {myCampaigns.map((myCampaign) => (
                <UserCampaign
                  changeRadio={this.changeRadio}
                  checkedRadio={checkedRadio}
                  key={`campaign-${myCampaign.id}`}
                  myCampaign={myCampaign}
                  setCampaign={setCampaign}
                />
              ))}
            </>
          );
        }}
      </Query>
    );
  }
}
